import "core-js/modules/es.number.constructor.js";
import AzButton from '~/components/_next/atoms/AzButton.vue';
import QuantitySelector from '~/components/Layout/Cart/AddToCart/QuantitySelector.vue';
export default defineComponent({
  name: 'AddToCart',
  components: {
    AzButton: AzButton,
    QuantitySelector: QuantitySelector
  },
  model: {
    prop: 'qty'
  },
  props: {
    isBookShop: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    qty: {
      type: [Number, String],
      default: 1
    },
    isSticky: {
      type: Boolean,
      default: false
    },
    buttonText: {
      type: String,
      default: 'Add to cart'
    }
  }
});